import { Card, Grid, NavBar } from "antd-mobile";
import { FileOutline, SearchOutline, UnorderedListOutline, UploadOutline } from 'antd-mobile-icons';
import { GridItem } from "antd-mobile/es/components/grid/grid";
import { useNavigate } from "react-router-dom";
import '../styles/HomePage.css'; // 确保创建对应的CSS文件

const HomePage = () => {
    const navigate = useNavigate();
    return (
        <div className="home-container">
            <NavBar back={null} className="home-navbar">检测设备管理系统</NavBar>
            <div className="home-content">
                <Grid columns={1} gap={16}>
                    <GridItem>
                        <Card
                            className="function-card"
                            onClick={() => navigate('/borrow')}
                        >
                            <div className="card-content">
                                <div className="card-icon">
                                    <UploadOutline fontSize={60} color="#1677ff" />
                                </div>
                                <div className="card-info">
                                    <div className="card-title">设备借出</div>
                                    <div className="card-desc">申请借用设备，快速处理</div>
                                </div>
                            </div>
                        </Card>
                    </GridItem>

                    <GridItem>
                        <Card
                            className="function-card"
                            onClick={() => navigate('/borrow-his')}
                        >
                            <div className="card-content">
                                <div className="card-icon">
                                    <FileOutline fontSize={60} color="#1677ff" />
                                </div>
                                <div className="card-info">
                                    <div className="card-title">我的借出</div>
                                    <div className="card-desc">查看已借设备，管理归还</div>
                                </div>
                            </div>
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card
                            className="function-card"
                            onClick={() => navigate('/approve-his')}
                        >
                            <div className="card-content">
                                <div className="card-icon">
                                    <UnorderedListOutline fontSize={60} color="#1677ff" />
                                </div>
                                <div className="card-info">
                                    <div className="card-title">我的审批</div>
                                    <div className="card-desc">查看审批清单，完成工作流程</div>
                                </div>
                            </div>
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card
                            className="function-card"
                            onClick={() => navigate('/available-devices')}
                        >
                            <div className="card-content">
                                <div className="card-icon">
                                    <SearchOutline fontSize={60} color="#1677ff" />
                                </div>
                                <div className="card-info">
                                    <div className="card-title">可借设备</div>
                                    <div className="card-desc">浏览可借用的设备列表</div>
                                </div>
                            </div>
                        </Card>
                    </GridItem>
                </Grid>
            </div>
        </div>
    );
};

export default HomePage;